'use client';

import '@ui5/webcomponents/dist/Title.js';
import { TitleLevel } from '../../enums/index.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `Title` component is used to display titles inside a page. It is a simple, large-sized text with explicit header/title semantics.
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/main-Title)
 */
const Title = withWebComponent('ui5-title', ['level', 'wrappingType'], [], [], []);
Title.displayName = 'Title';
Title.defaultProps = {
  level: TitleLevel.H2
};
export { Title };